<template>
  <div>
    <h3>{{ $t("overview.network.organizers.header") }}</h3>
    <vca-row>
      <div class="clickable" @click="navCrews">
        {{ $t("overview.network.organizers.total") }}
      </div>
      <div class="bold">{{ organizers.length }}</div>
    </vca-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "OrganizersDashlet",
  methods: {
    navCrews() {
      this.$router.push({ path: "/network/organizers" });
    },
  },
  computed: {
    ...mapGetters({
      organizers: "organizers/list",
    }),
  },
};
</script>
